package gr.tech.lkpksignature.components.SignaturePad

import androidx.compose.runtime.*
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.graphics.Colors
import com.varabyte.kobweb.compose.ui.modifiers.*
import com.varabyte.kobweb.compose.ui.toAttrs
import com.varabyte.kobweb.silk.components.forms.Button
import com.varabyte.kobweb.silk.components.forms.ButtonSize
import com.varabyte.kobweb.silk.style.CssStyle
import com.varabyte.kobweb.silk.style.toAttrs
import com.varabyte.kobweb.silk.style.toModifier
import org.jetbrains.compose.web.css.LineStyle
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.dom.Canvas
import org.jetbrains.compose.web.dom.Text

val signatureCanvasStyle = CssStyle {
    base {
        Modifier
            .backgroundColor(Colors.White)
            .border(2.px, LineStyle.Solid, Colors.Black)
            .borderRadius(5.px)
    }
}

val basicButtonStyle = CssStyle {
    base {
        Modifier
            .width(200.px)
            .height(50.px)
            .color(Colors.White)
            .backgroundColor(Colors.SteelBlue)
    }
}



//Canvas element to use for signature pad.
@Composable
fun SignatureCanvas() {
    Canvas(attrs = signatureCanvasStyle.toModifier()
        .toAttrs {
            id("canvas")
    }) {}
}